import React from 'react'
import Experiment from '@mc/experiments-react'
import { PROMO_BANNER_200_CLASSES_FLAG_NAME } from '../../constants'
import { BannerTitleVariant } from '../BannerTitleVariant'

export const BannerTitleWrapper = ({
  control,
  keepWidth,
}: {
  control: React.ReactNode
  keepWidth?: boolean
}) => (
  <Experiment
    name={PROMO_BANNER_200_CLASSES_FLAG_NAME}
    control={() => control}
    variant_1={() => <BannerTitleVariant control={control} />}
    variant_2={() => (
      <BannerTitleVariant control={control} keepWidth={keepWidth} rotate />
    )}
    track={false}
  />
)
